import { useQuery } from "@tanstack/react-query";
import { prospectionApi } from "./api";

/**
 * Suivi d'un travail de fond : interrogation courte tant qu'il tourne,
 * arrêt net dès qu'il se termine. Pas de WebSocket pour un travail unitaire.
 */
export function useSuiviAnalyse(scrapeRunId: string | null) {
  return useQuery({
    queryKey: ["scrape", scrapeRunId],
    queryFn: () => prospectionApi.statut(scrapeRunId!),
    enabled: Boolean(scrapeRunId),
    refetchInterval: q => {
      const s = q.state.data?.statut;
      return s === "termine" || s === "echoue" || s === "annule" ? false : 2000;
    }
  });
}
